import { computed, Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useMetadataExperienceApi } from "@/composables/useMetadataExperienceApi";
import { useRouteParams } from "@vueuse/router";

export const EXPERIENCE_ADDITIONAL_CITIES_QUERY_KEY = "experience-additional-cities";

export function useExperienceAdditionalCitiesQuery(experienceId: Ref<string>) {
  const { getAdditionalCitiesById } = useMetadataExperienceApi();

  return useQuery({
    queryKey: [EXPERIENCE_ADDITIONAL_CITIES_QUERY_KEY, experienceId],
    queryFn: () => getAdditionalCitiesById(experienceId.value),
    select: ({ data }) => data,
    enabled: computed(() => !!experienceId.value),
  });
}

export function useCurrentExperienceAdditionalCitiesQuery() {
  const experienceId = useRouteParams<string>("id");

  return useExperienceAdditionalCitiesQuery(experienceId);
}
